import PropTypes from 'prop-types';

import { Card, Chip, CardContent, Typography } from '@mui/joy';

import i18n from '@/i18n';
import { Img } from './Img';

import { MusicNote } from '@phosphor-icons/react/dist/ssr';

export function RecordingCard({
  name,
  thumbnailUrl,
  imageUrl,
  isrc,
  is_public_domain,
  ...props
}) {
  return (
    <Card sx={{ padding: 0}} {...props}>
      <Img PlaceholderIcon={MusicNote} src={thumbnailUrl || imageUrl} sx={{ aspectRatio: '1/1' }} />
      <CardContent sx={{ padding: 1, paddingTop: 0, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
        <Typography s>{isrc ?? '-'}</Typography>
        {is_public_domain && (
          <Chip size="sm" color="success" sx={{ alignSelf: 'flex-start', mb: 1 }}>
            {i18n.t('public-domain')}
          </Chip>
        )}
        <Typography sx={{
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontWeight: '800',
          overflow: 'hidden'
        }} level="h4">{name}</Typography> 
      </CardContent>
    </Card>
  )
}

RecordingCard.propTypes = {
  name: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  isrc: PropTypes.string,
  is_public_domain: PropTypes.bool
}